import React, { useEffect } from "react";
import Home from "./pages/Home";
import "./assets/styles/global.css";
import "regenerator-runtime/runtime";
import { AuthProvider } from "@/features/auth/context/AuthContext";
import { AppRoutes } from "@/core/router/AppRoutes";
import { ApolloProvider } from "@/lib/apollo/ApolloProvider";
import { ToastContainer } from "react-toastify";
import { useUniversity } from "@/features/auth/hooks/useUniversity";
import FallbackLoader from "@/common/components/shared/FallbackLoader";
import { initGA } from "@/lib/analytics/ga4";
import { PostHogProvider } from "posthog-js/react";

const options = {
  api_host: "https://us.i.posthog.com",
};

function App() {
  const { university, loading, error } = useUniversity();

  // Initialize Google Analytics with university data
  useEffect(() => {
    if (university) {
      initGA(university);
    } else {
      initGA();
    }
  }, [university]);

  // Update document title with university name
  useEffect(() => {
    const defaultTitle = "Learning Platform";

    if (university && university.name) {
      // Replace HTML entities and sanitize the university name
      const sanitizedName = university.name
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .trim();

      document.title = sanitizedName || defaultTitle;
    } else if (!loading && !error) {
      // Set default title if university data loaded successfully but no named university
      document.title = defaultTitle;
    }

    // Clean up function to reset title if component unmounts
    return () => {
      document.title = defaultTitle;
    };
  }, [university, loading, error]);

  if (loading) {
    return <FallbackLoader message="Initializing.." />;
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center w-full min-h-[500px] px-4">
        <p className="text-red-500">
          Failed to load university configuration. Please try again later.
        </p>
      </div>
    );
  }

  return (
    <PostHogProvider
      apiKey="phc_vxqUbnVSzRh2L6RZgdXISqioeHu6SLLLxnRWaYB2aFZ"
      options={options}
    >
      <AuthProvider university={university}>
        <ApolloProvider>
          <AppRoutes university={university} />
          <ToastContainer newestOnTop theme="colored" position="top-right" />
        </ApolloProvider>
      </AuthProvider>
    </PostHogProvider>
  );
}

export default App;
